import { Outlet } from 'react-router'
import { useAuth } from './AuthContext'
import PendingPanel from '../routes/PendingPanel'

/**
 * Approval gate (SPEC §A) — UI layer. Mount INSIDE <RequireAuth> so `user` is
 * non-null. Non-approved (pending/rejected) tenants get a bare locked panel and the
 * app shell + privileged routes never render. Approval is ALSO enforced server-side
 * on every privileged endpoint (gate.py), so this is convenience, not the boundary.
 */
export default function RequireApproved() {
  const { user } = useAuth()
  // 0017 pkt 1 (PM): a PENDING account walks into the shell — read-only routes (clip
  // packs, hooks, prices, the library) render, onboarding shows "Konto czeka" as a real
  // step, and upload/render stay 403 `account_pending` on the server with their buttons
  // disabled. Only a REJECTED account still gets the bare locked panel.
  if (user && user.approval_status === 'rejected') return <PendingPanel />
  return <Outlet />
}
